import TranslationHelper from '../../../../helpers/TranslationHelper';
import React, { ChangeEvent } from 'react';
import FieldWithTooltip from '../../../FieldWithTooltip';
import { useStyles } from '../../Themable.hooks';
import { TextField } from '@material-ui/core';

interface IOwnProps {
    id: string;
    label: string;
    nameInput: {
        name: string;
        setName: (value: string) => void;
    };
    tooltipTitle?: string;
}

export const NameFilter = ({
    nameInput,
    tooltipTitle,
    id,
    label,
}: IOwnProps) => {
    const { name, setName } = nameInput;
    const classes = useStyles();
    const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    };
    return (
        <FieldWithTooltip title={tooltipTitle}>
            <TextField
                name={id}
                id={id}
                label={TranslationHelper.translate(label)}
                value={name}
                onChange={handleChangeName}
                className={classes.searchByName}
            />
        </FieldWithTooltip>
    );
};
